/**
 * Structured console logging for feature modules.
 *
 * Info is development-only; warnings and errors are always written, because
 * they are what a support engineer asks a user to copy from the console. Never
 * log what a user typed: questions can name customers or people. Log its
 * length instead.
 */
import { ApiError } from "./api";

export type LogLevel = "info" | "warn" | "error";
export type LogFields = Record<string, string | number | boolean | null | undefined>;
export type Logger = (level: LogLevel, event: string, fields?: LogFields) => void;

export function createLogger(scope: string): Logger {
  return (level, event, fields = {}) => {
    if (level === "info" && !import.meta.env.DEV) return;
    console[level](`${scope}.${event}`, fields);
  };
}

/** What can safely be logged about a failure: codes and ids, never bodies. */
export function errorFields(error: unknown): LogFields {
  if (error instanceof ApiError) {
    return {
      status: error.status,
      code: error.code,
      requestId: error.requestId,
      retryable: error.retryable,
    };
  }
  return { code: error instanceof Error ? error.name : "unknown" };
}
